import { createApi } from '@reduxjs/toolkit/query/react';
import { createExtendedTokenBaseQuery } from './baseQuery';
import { ManufacturerData } from '@/types/asset.types';

export const manufacturerDataApi = createApi({
    reducerPath: 'manufacturerDataApi',
    baseQuery: createExtendedTokenBaseQuery(''),
    tagTypes: ['ManufacturerData'],
    endpoints: (builder) => ({
        getmanufacturerData: builder.query<ManufacturerData, {dropdown?: boolean} | void> ({
           query: (params) => ({
            url: '/assets/manufacturers/',
            method: 'GET',
            params
           }),
           providesTags: ['ManufacturerData'],
        }),

        // New dropdown-specific endpoint
        getManufacturerDataDropdown: builder.query<
        ManufacturerData,
        {
            page?: number;
            limit?: number;
            search?: string;
            dropdown?: boolean;
        }
        >({
        query: (params) => ({
            url: '/assets/manufacturers/dropdown/',
            method: 'GET',
            params,
        }),
        providesTags: ['ManufacturerData'],
        }),
    })
})

export const {useGetmanufacturerDataQuery, useGetManufacturerDataDropdownQuery} = manufacturerDataApi;